import HundredBricksAPIError from '../../../HundredBricksAPIError';
class SoldInvestmentsError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('SoldInvestmentsError', ...args);
    }
}
export default SoldInvestmentsError;
